<template>
  <!-- 理论考试组卷 -->
  <div>
    <audio @canplay="canplay" :setAudioName="setAudioName" ref="audio" :src="haveDuration" />
    <div v-if="activeMenu" class="testGroupPaper">
      <el-row class="tableHearInputBox" type="flex" justify="space-between">
        <el-col>
          <el-input
            v-model.trim="query.query"
            placeholder="请输入科目名称"
            style="width: 200px; margin-right: 10px"
            @keyup.enter.native="freshLoad"
            @clear="
              query.query = '';
              freshLoad();
            "
            clearable
            suffix-icon="el-icon-search"
          ></el-input>
          <Debounce>
            <el-button style="margin-right: 10px" size="medium" @click="freshLoad">查询</el-button>
          </Debounce>
          <el-select
            v-model="query.applicationYear"
            @change="tableLoad"
            filterable
            placeholder="请选择"
          >
            <el-option label="全部年份" value=""></el-option>
            <el-option
              v-for="item in yearSelectList"
              :key="item.parentId"
              :label="item.parentId"
              :value="item.parentId"
            ></el-option>
          </el-select>
        </el-col>
        <el-button
          size="small"
          type="primary"
          style="margin-left: 10px; margin-right: 10px"
          @click="groupCopy"
          >组卷复制</el-button
        >
      </el-row>
      <el-table
        :data="tableList"
        tooltip-effect="dark"
        border
        ref="elTable"
        style="width: 100%"
        :header-cell-style="$store.getters.getTableHeadStyle"
        v-loading="loading"
        element-loading-text="加载中"
        :height="$store.getters.getTableHeight"
      >
        <el-table-column
          prop="appYear"
          label="考试年份"
          :show-overflow-tooltip="true"
          align="center"
        ></el-table-column>
        <el-table-column prop="kspc" label="考试批次" align="center">
          <template slot-scope="scope">
            {{
              scope.row.kspc === 1
                ? '春季'
                : scope.row.kspc === 2
                ? '夏季'
                : scope.row.kspc === 3
                ? '秋季'
                : scope.row.kspc === 4
                ? '冬季'
                : ''
            }}
          </template>
        </el-table-column>

        <el-table-column
          prop="subjectName"
          label="考试科目"
          :show-overflow-tooltip="true"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="subjectLevelName"
          label="级别"
          :show-overflow-tooltip="true"
          align="center"
        ></el-table-column>
        <el-table-column
          label="理论考试时间"
          width="330px"
          :show-overflow-tooltip="true"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.startTime }} -- {{ scope.row.endTime }}
          </template>
        </el-table-column>
        <el-table-column
          prop="time"
          label="考试时长"
          :show-overflow-tooltip="true"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="needing"
          label="考前注意事项"
          :show-overflow-tooltip="true"
          align="center"
        >
          <template slot-scope="scope">
            <Debounce v-if="scope.row.needing == null">
              <!-- <el-upload v-if="new Date(scope.row.startTime).getTime() > new Date().getTime()" ref="upload"
                                accept=".pdf,.PDF" :on-success="(res => { handleUploadSuccess(res, scope.row) })"
                                :before-upload="(file => { beforeUpload(file, scope.row) })" action="api/upload"
                                :show-file-list="false">
                                <el-button type="text" size="medium">+ 上传
                                </el-button>
                            </el-upload> -->
              <el-button
                v-if="new Date(scope.row.startTime).getTime() > new Date().getTime()"
                type="text"
                size="medium"
                @click="setMatter(scope.row)"
                >+ 添加</el-button
              >
              <p v-else class="forGrey">+ 添加</p>
            </Debounce>
            <div v-else class="lookInfo">
              <Debounce>
                <el-button type="text" size="medium" @click="setMatter(scope.row)">查看 </el-button>
              </Debounce>
              <!-- <div v-if="new Date(scope.row.startTime).getTime() > new Date().getTime()">
                                <img @click="deleAudioInfo(scope.row)" class="icons" src="@/assets/img/clean1.png" alt="">
                            </div> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="type1"
          label="乐理知识占比"
          :show-overflow-tooltip="true"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.type1 ? `${scope.row.type1}%` : '未设置' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="type2"
          label="音乐素养占比"
          :show-overflow-tooltip="true"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.type2 ? `${scope.row.type2}%` : '未设置' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="type3"
          label="上传音频占比"
          :show-overflow-tooltip="true"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.type3 ? `${scope.row.type3}%` : '未设置' }}
          </template>
        </el-table-column>
        <el-table-column prop="type4" label="练耳占比" :show-overflow-tooltip="true" align="center">
          <template slot-scope="scope">
            {{ scope.row.type4 ? `${scope.row.type4}%` : '未设置' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="id"
          label="正式考试试卷"
          :show-overflow-tooltip="true"
          align="center"
        >
          <template slot-scope="scope">
            <Debounce
              v-if="
                new Date(scope.row.startTime).getTime() > new Date().getTime() && !scope.row.type4
              "
            >
              <el-button type="text" size="medium" @click="operatInfo(1, scope.row)"
                >设置
              </el-button>
            </Debounce>
            <Debounce v-else-if="scope.row.type4">
              <el-button type="text" size="medium" @click="operatInfo(4, scope.row)"
                >查看
              </el-button>
            </Debounce>
            <p v-else class="forGrey">设置</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="ids"
          label="模拟考试试卷"
          :show-overflow-tooltip="true"
          align="center"
        >
          <template slot-scope="scope">
            <Debounce v-if="scope.row.ids == null">
              <el-button
                v-if="new Date(scope.row.startTime).getTime() > new Date().getTime()"
                type="text"
                size="medium"
                @click="operatInfo(2, scope.row)"
                >添加
              </el-button>
              <p class="forGrey" v-else>添加</p>
            </Debounce>
            <Debounce v-else>
              <el-button type="text" size="medium" @click="operatInfo(3, scope.row)"
                >查看
              </el-button>
            </Debounce>
          </template>
        </el-table-column>
      </el-table>
      <Pagination
        :total="query.total"
        :page.sync="query.pageNum"
        :limit.sync="query.pageSize"
        class="pagination-content"
        @pagination="tableLoad"
      />
      <el-dialog
        custom-class="dailogComponents"
        title="考前注意事项"
        top="5%"
        :visible.sync="visible"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        :before-close="closeDialog"
        width="920px"
      >
        <div class="dialogBox">
          <el-input
            :disabled="!(new Date(matterTime).getTime() > new Date().getTime())"
            style="width: 95%; height: 90%"
            type="textarea"
            :rows="8"
            maxLength="1000"
            placeholder="请输入考前注意事项"
            v-model="matter.needing"
          >
          </el-input>
          <!-- <iframe :src="needPDF.url" frameborder="0" style="width: 90%; height: 100%"></iframe> -->
          <!-- <autioCate :name="false" width="300px" height="50px" :audioSrc="needPDF" /> -->
        </div>
        <el-row
          v-if="new Date(matterTime).getTime() > new Date().getTime()"
          style="padding-bottom: 15px"
          type="flex"
          justify="center"
        >
          <el-button size="medium" @click="closeDialog">取消</el-button>
          <Debounce>
            <el-button size="medium" type="primary" @click="sureMatter">确定</el-button>
          </Debounce>
        </el-row>
      </el-dialog>
      <el-dialog
        custom-class="dailogComponents"
        title="组卷复制"
        :visible.sync="visible1"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        width="800px"
      >
        <div class="dialogBox1">
          <div class="dialogContent">
            <div class="orginGroup">
              <div class="title">选择原组卷</div>
              <el-row class="rowBox">
                <el-col :span="8">
                  <p><span style="color: red">*</span>考试年份:</p>
                </el-col>
                <el-col :offset="1">
                  <el-select
                    v-model="oldpaper.appYear"
                    placeholder="请选择"
                    @change="handleYearChange"
                  >
                    <el-option
                      v-for="item in years"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-col>
              </el-row>

              <el-row class="rowBox">
                <el-col :span="8">
                  <p><span style="color: red">*</span>考试批次:</p>
                </el-col>
                <el-col :offset="1">
                  <el-select
                    v-model="oldpaper.kspc"
                    placeholder="请选择"
                    @change="handleBatchChange"
                    :disabled="!oldpaper.appYear"
                  >
                    <el-option
                      v-for="batch in filteredBatches"
                      :key="batch.value"
                      :label="batch.label"
                      :value="batch.value"
                    />
                  </el-select>
                </el-col>
              </el-row>

              <el-row class="rowBox">
                <el-col :span="8">
                  <p><span style="color: red">*</span>考试科目:</p>
                </el-col>
                <el-col :offset="1">
                  <el-select
                    v-model="oldpaper.subjectId"
                    placeholder="请选择"
                    @change="handleSubjectChange"
                    :disabled="!oldpaper.kspc"
                  >
                    <el-option
                      v-for="subject in filteredSubjects"
                      :key="subject.value"
                      :label="subject.label"
                      :value="subject.value"
                    />
                  </el-select>
                </el-col>
              </el-row>

              <el-row class="rowBox">
                <el-col :span="8">
                  <p><span style="color: red">*</span>级别:</p>
                </el-col>
                <el-col :offset="1">
                  <el-select
                    v-model="oldpaper.testLevel"
                    placeholder="请选择"
                    @change="handleLevelChange"
                    :disabled="!oldpaper.subjectId"
                  >
                    <el-option
                      v-for="level in filteredLevels"
                      :key="level.value"
                      :label="level.label"
                      :value="level.value"
                    />
                  </el-select>
                </el-col>
              </el-row>
            </div>
            <div class="centreLine">
              <img src="@/assets/img/centreLine.png" alt="" />
            </div>
            <div class="newGroup">
              <div class="title">选择新组卷</div>
              <el-row class="rowBox">
                <el-col :span="8">
                  <p><span style="color: red">*</span>考试年份:</p>
                </el-col>
                <el-col :offset="1">
                  <el-select
                    v-model="newpaper.appYear"
                    placeholder="请选择"
                    @change="handleYearChange1"
                  >
                    <el-option
                      v-for="item in years1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-col>
              </el-row>

              <el-row class="rowBox">
                <el-col :span="8">
                  <p><span style="color: red">*</span>考试批次:</p>
                </el-col>
                <el-col :offset="1">
                  <el-select
                    v-model="newpaper.kspc"
                    placeholder="请选择"
                    @change="handleBatchChange1"
                    :disabled="!newpaper.appYear"
                  >
                    <el-option
                      v-for="batch in filteredBatches1"
                      :key="batch.value"
                      :label="batch.label"
                      :value="batch.value"
                    />
                  </el-select>
                </el-col>
              </el-row>

              <el-row class="rowBox">
                <el-col :span="8">
                  <p><span style="color: red">*</span>考试科目:</p>
                </el-col>
                <el-col :offset="1">
                  <el-select
                    v-model="newpaper.subjectId"
                    placeholder="请选择"
                    @change="handleSubjectChange1"
                    :disabled="!newpaper.kspc"
                  >
                    <el-option
                      v-for="subject in filteredSubjects1"
                      :key="subject.value"
                      :label="subject.label"
                      :value="subject.value"
                    />
                  </el-select>
                </el-col>
              </el-row>

              <el-row class="rowBox">
                <el-col :span="8">
                  <p><span style="color: red">*</span>级别:</p>
                </el-col>
                <el-col :offset="1">
                  <el-select
                    v-model="newpaper.testLevel"
                    placeholder="请选择"
                    @change="handleLevelChange1"
                    :disabled="!newpaper.subjectId"
                  >
                    <el-option
                      v-for="level in filteredLevels1"
                      :key="level.value"
                      :label="level.label"
                      :value="level.value"
                    />
                  </el-select>
                </el-col>
              </el-row>
            </div>
          </div>
          <el-row type="flex" class="dailogButBox" justify="center">
            <el-col :span="7">
              <el-button size="medium" @click="visible1 = false">取消</el-button>
            </el-col>
            <el-col :span="4">
              <el-button size="medium" type="primary" @click="copySubmit">确认</el-button>
            </el-col>
          </el-row>
        </div>
      </el-dialog>
    </div>
    <router-view v-else />
  </div>
</template>

<script>
import FileDropDown from '@/views/admin/components/FileDropDown';
import autioCate from '../../../components/autioCate.vue';

export default {
  name: 'testGroupPaper',
  components: {
    FileDropDown,
    autioCate,
  },
  data() {
    return {
      tableList: [],
      loading: true,
      roleList: [],
      visible: false,
      visible1: false,
      visibleObj1: {},
      visibleType: 0, //删除
      visibleObj: {
        needing: '', //考前注意事项
        subjectLevel: '', //级别
        llksTime: '', //理论考试时间
        time: [''], //考试时长
        appYear: '', //考试年份
        subjectId: '', //考试科目
      },
      query: {
        query: '',
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
        total: 1, // 总条数
        applicationYear: '',
      },
      gsSeleList: [],
      appYearList: [],
      jbList: [],
      llksTimeList: [],
      yearSelectList: [],
      setAudioName: '',
      haveDuration: '',
      toData: {},
      needPDF: {},
      matter: { examInformationId: '', needing: '', testLevel: '' },
      matterTime: '',
      years: [], // 存储考试年份
      batches: [], // 存储考试批次
      subjects: [], // 存储考试科目
      levels: [], // 存储级别
      years1: [], // 存储考试年份
      batches1: [], // 存储考试批次
      subjects1: [], // 存储考试科目
      levels1: [], // 存储级别
      oldpaper: {
        appYear: null, // 年份
        examInformationId: null,
        kspc: null, // 批次
        subjectId: null, // 科目
        testLevel: null, // 级别
      },
      newpaper: {
        appYear: null, // 年份
        examInformationId: null,
        kspc: null, // 批次
        subjectId: null, // 科目
        testLevel: null, // 级别
      },
    };
  },
  mounted() {
    this.getSelectList();
  },
  methods: {
    //组卷复制提交
    copySubmit() {
      this.$axios
        .post(`/basicQuestionsScore/copyScore`, {
          oldpaper: this.oldpaper,
          newpaper: this.newpaper,
        })
        .then((res) => {
          this.$message({ type: 'success', message: '组卷复制成功!', duration: 1000 });
          this.visible1 = false;
          this.frechLoad();
        });
    },
    groupCopy(row) {
      this.visible1 = true;
      this.oldpaper = {
        appYear: null, // 年份
        examInformationId: null,
        kspc: null, // 批次
        subjectId: null, // 科目
        testLevel: null, // 级别
      };
      this.newpaper = {
        appYear: null, // 年份
        examInformationId: null,
        kspc: null, // 批次
        subjectId: null, // 科目
        testLevel: null, // 级别
      };
    },
    closeDialog() {
      this.matter = { examInformationId: '', needing: '', testLevel: '' };
      this.visible = false;
    },
    setMatter(row) {
      console.log(771, row);
      this.matter.examInformationId = row.id;
      this.matter.testLevel = row.subjectLevel;
      this.matter.needing = row.needing;
      this.matterTime = row.startTime;
      this.toLooks = false;
      this.visible = true;
    },
    sureMatter() {
      this.$axios.post(`/basicQuestionsScore/update/needing`, this.matter).then((res) => {
        this.$message({ type: 'success', message: '考前注意事项设置成功!', duration: 1000 });
        this.tableLoad();
        this.visible = false;
      });
    },
    changeYear() {
      this.frechLoad();
    },
    getSelectList() {
      this.$axios.get('/apply/yearLine').then((res) => {
        let data = res.data.data;
        this.yearSelectList = data;
        if (Array.isArray(data) && data[0].parentId) {
          this.query.applicationYear = data[0].parentId;
        }
        this.tableLoad();
      });
      this.$axios.get('/basicQuestionsScore/copyYear').then((res) => {
        this.years = res.data.data;
        // 默认选择最大年份
        if (this.years.length > 0) {
          this.oldpaper.appYear = this.years[0].value;
          this.handleYearChange(this.oldpaper.appYear);
        }
      });
      this.$axios.get('/basicQuestionsScore/newYear').then((res) => {
        this.years1 = res.data.data;
        // 默认选择最大年份
        if (this.years1.length > 0) {
          this.newpaper.appYear = this.years1[0].value;
          this.handleYearChange1(this.newpaper.appYear);
        }
      });
    },
    //原组卷
    handleYearChange(year) {
      this.oldpaper.kspc = null; // 重置批次
      this.oldpaper.subjectId = null; // 重置科目
      this.oldpaper.testLevel = null; // 重置级别
      this.oldpaper.examInformationId = null;
    },
    //原组卷
    handleBatchChange() {
      this.oldpaper.subjectId = null; // 重置科目
      this.oldpaper.testLevel = null; // 重置级别
      this.oldpaper.examInformationId = null;
    },
    //原组卷
    handleSubjectChange() {
      this.oldpaper.testLevel = null; // 重置级别
      this.oldpaper.examInformationId = null;
    },
    //原组卷
    handleLevelChange(val) {
      // 根据选中的级别找到对应的级别对象
      const selectedLevelData = this.filteredLevels.find((level) => level.value === val);
      if (selectedLevelData) {
        // 将parentId赋值给examInformationId
        this.oldpaper.examInformationId = selectedLevelData.parentId;
      } else {
        this.oldpaper.examInformationId = null; // 如果没有找到，重置examInformationId
      }
    },
    //新组卷
    handleYearChange1(year) {
      this.newpaper.kspc = null; // 重置批次
      this.newpaper.subjectId = null; // 重置科目
      this.newpaper.testLevel = null; // 重置级别
      this.newpaper.examInformationId = null;
    },
    //新组卷
    handleBatchChange1() {
      this.newpaper.subjectId = null; // 重置科目
      this.newpaper.testLevel = null; // 重置级别
      this.newpaper.examInformationId = null;
    },
    handleSubjectChange1() {
      this.newpaper.testLevel = null; // 重置级别
      this.newpaper.examInformationId = null;
    },
    handleLevelChange1(val) {
      // 根据选中的级别找到对应的级别对象
      const selectedLevelData = this.filteredLevels1.find((level) => level.value === val);
      if (selectedLevelData) {
        // 将parentId赋值给examInformationId
        this.newpaper.examInformationId = selectedLevelData.parentId;
      } else {
        this.newpaper.examInformationId = null; // 如果没有找到，重置examInformationId
      }
    },
    frechLoad() {
      this.query.pageNum = 1;
      this.tableLoad();
    },
    canplay() {
      let data = {
        ...this.toData.res.data,
      };
      data.time = this.$refs.audio.duration;
      this.$axios
        .post(
          `/basicQuestionsScore/update/${this.toData.row.id}/${this.toData.row.subjectLevel}`,
          data
        )
        .then((res) => {
          this.$message({ type: 'success', message: '考前注意事项上传成功', duration: 1000 });
          this.tableLoad();
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    deleAudioInfo(row) {
      this.$dailog({
        title: '删除',
        context: '是否删除考前注意事项?',
        callbackFun: () => {
          this.$axios
            .delete(`/basicQuestionsScore/delete/${row.id}/${row.subjectLevel}`, {
              data: row.needing,
            })
            .then((res) => {
              this.loading = true;
              this.$message({ type: 'success', message: '删除成功!', duration: 1000 });
              this.tableLoad();
            });
        },
      });
    },
    // 限制文件大小 30m
    beforeUpload(file, row) {
      console.log(99, file);
      const isPDF = file.type === 'application/pdf';
      const isLt30M = file.size / 1024 / 1024 < 30;
      if (!isPDF) {
        this.$message.error('上传文件只能是 pdf 格式!');
      }
      if (!isLt30M) {
        this.$message.error('上传文件大小不能超过30MB!');
      }
      if (isPDF && isLt30M) {
        this.loading = true;
      }
      return isPDF && isLt30M;
    },
    handleUploadSuccess(res, row) {
      if (res.code == '10000') {
        this.toData = { res: res, row: row };
        // this.haveDuration = res.data.url
        let data = {
          ...this.toData.res.data,
        };
        data.time = this.$refs.audio.duration;
        this.$axios
          .post(
            `/basicQuestionsScore/update/${this.toData.row.id}/${this.toData.row.subjectLevel}`,
            data
          )
          .then((res) => {
            this.$message({ type: 'success', message: '考前注意事项上传成功', duration: 1000 });
            this.tableLoad();
          })
          .catch((err) => {
            this.loading = false;
          });
        this.loading = false;
      } else {
        this.$message({ type: 'error', message: res.msg, duration: 1000 });
        this.loading = false;
      }
    },
    lookNeed(row) {
      this.visible = true;
      this.toLooks = true;
      this.matter.needing = row.needing;
    },
    addKnow() {
      if (this.visibleObj.time.length < 21) {
        this.visibleObj.time.push('');
      }
    },
    deleteKnow(num) {
      this.visibleObj.time.splice(num, 1);
    },
    freshLoad() {
      this.query.pageNum = 1;
      this.tableLoad();
    },
    tableLoad() {
      this.$axios.post('/basicQuestionsScore/list', this.query).then((res) => {
        let { list, total } = res.data.data;
        this.tableList = list;
        this.query.total = total;
        this.loading = false;
      });
    },
    operatInfo(type, row) {
      if (type === 1) {
        if (row.needing == null) {
          this.$message({ type: 'warning', message: '请先设置考前注意事项', duration: 1000 });
          return;
        }
        this.$router.push({
          path: '/examManag/testGroupPaper/formalExamination',
          query: {
            visiType: 1,
            row: JSON.stringify(row),
            alter: new Date(row.startTime).getTime() > new Date().getTime(),
          },
        });
      } else if (type === 2) {
        if (row.needing == null) {
          this.$message({ type: 'warning', message: '请先设置考前注意事项', duration: 1000 });
          return;
        }
        this.$router.push({
          path: '/examManag/testGroupPaper/practiceTest',
          query: {
            visiType: 1,
            row: JSON.stringify(row),
            alter: new Date(row.startTime).getTime() > new Date().getTime(),
          },
        });
      } else if (type === 3) {
        this.$router.push({
          path: '/examManag/testGroupPaper/practiceTest',
          query: {
            visiType: 2,
            row: JSON.stringify(row),
            alter: new Date(row.startTime).getTime() > new Date().getTime(),
          },
        });
      } else if (type === 4) {
        this.$router.push({
          path: '/examManag/testGroupPaper/formalExamination',
          query: {
            visiType: 2,
            row: JSON.stringify(row),
            alter: new Date(row.startTime).getTime() > new Date().getTime(),
          },
        });
      }
    },
    //密码初始化
    initPassword(row) {
      this.$axios({
        method: 'post',
        url: '/judge/initial',
        data: [
          {
            needing: row.needing,
            subjectLevel: row.subjectLevel,
            passWord: row.passWord,
            time: row.time,
            userId: row.userId,
            appYear: row.appYear,
          },
        ],
      }).then((res) => {
        this.$message({
          type: 'success',
          message: '密码初始化成功!',
          duration: 1000,
        });
      });
    },
    submit() {
      let { needing, subjectLevel, llksTime, time, appYear, subjectName } = this.visibleObj;
      if (appYear === '' || subjectLevel === '' || needing === '' || passWord === '') {
        this.$message({
          type: 'warning',
          message: '必填项不能为空!',
          duration: 1000,
        });
        return;
      }
      let subType = this.visibleType === 1 ? 'post' : 'put';
      this.$axios({
        method: subType,
        url: '/judge',
        data: this.visibleObj,
      }).then((res) => {
        this.$message({
          type: 'success',
          message: '保存成功!',
          duration: 1000,
        });
        this.visible = false;
        this.tableLoad();
      });
    },
  },
  computed: {
    activeMenu() {
      if (this.$route.path == '/examManag/testGroupPaper') {
        return true;
      } else {
        return false;
      }
    },
    //原组卷
    filteredBatches() {
      // 根据选中的年份过滤批次
      const yearData = this.years.find((year) => year.value === this.oldpaper.appYear);
      return yearData ? yearData.children : [];
    },
    filteredSubjects() {
      // 根据选中的批次过滤科目
      const batchData = this.filteredBatches.find((batch) => batch.value === this.oldpaper.kspc);
      return batchData ? batchData.children : [];
    },
    filteredLevels() {
      // 根据选中的科目过滤级别
      const subjectData = this.filteredSubjects.find(
        (subject) => subject.value === this.oldpaper.subjectId
      );
      return subjectData ? subjectData.children : [];
    },
    //新组卷
    filteredBatches1() {
      // 根据选中的年份过滤批次
      const yearData = this.years1.find((year) => year.value === this.newpaper.appYear);
      return yearData ? yearData.children : [];
    },
    filteredSubjects1() {
      // 根据选中的批次过滤科目
      const batchData = this.filteredBatches1.find((batch) => batch.value === this.newpaper.kspc);
      return batchData ? batchData.children : [];
    },
    filteredLevels1() {
      // 根据选中的科目过滤级别
      const subjectData = this.filteredSubjects1.find(
        (subject) => subject.value === this.newpaper.subjectId
      );
      return subjectData ? subjectData.children : [];
    },
  },
  watch: {
    $route() {
      this.tableLoad();
    },
  },
};
</script>
<style lang="scss" scoped>
.forGrey {
  color: #999;
  cursor: pointer;
}

.dialogBox {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 15px;
}
.dialogBox1 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: 15px;
  .dialogContent {
    display: flex;
    .orginGroup {
      margin: 8px 10px 10px 15px;
      width: 400px;
      height: 300px;
      border: 1px solid rgb(242, 242, 242);
      // background-color: aqua;
      .title {
        width: 100%;
        height: 34px;
        line-height: 34px;
        text-align: center;
        background-color: rgb(242, 242, 242);
        color: #000;
        font-size: 14px;
        font-weight: bold;
      }
      .rowBox {
        display: flex;
        align-items: center;
        margin: 20px 0 15px 14px;
      }
    }
    .centreLine {
      width: 50px;
      height: 300px;
      line-height: 350px;
      text-align: center;
      // background-color: #999;
    }
    .newGroup {
      margin: 8px 15px 10px 10px;
      width: 400px;
      height: 300px;
      border: 1px solid rgb(242, 242, 242);
      // background-color: aqua;
      .title {
        width: 100%;
        height: 34px;
        line-height: 34px;
        text-align: center;
        background-color: rgb(242, 242, 242);
        color: #000;
        font-size: 14px;
        font-weight: bold;
      }
      .rowBox {
        display: flex;
        align-items: center;
        margin: 20px 0 15px 14px;
      }
    }
  }
}

.lookInfo {
  position: relative;

  .icons {
    cursor: pointer;
    right: 2px;
    top: 50%;
    transform: translate(0, -50%);
    width: 15px;
    height: 15px;
    position: absolute;
  }
}

.iconDiv {
  width: 100%;
  display: flex;
  justify-content: space-between;

  .changeIcon {
    width: 46%;
  }
}
</style>
